module.exports = __webpack_public_path__ + "img/element_invite.d842fa1f.svg";